import { Pagination } from '@/domain/entities/Pagination'
import { RoleCMSS, RoleCMSData } from '@/domain/entities/AdminCMSRole'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class AdminCMSRoleDataMapper extends BaseResponseMapper {
  public convertAdminCMSRoleFromApi(result: AxiosResponse<any>): RoleCMSS {
    const { data } = result
    return new RoleCMSS(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new RoleCMSData(
            val.id,
            val.role_name,
            val.menu,
            val.need_sales_code,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
